import axios from "axios";
import qs from 'qs'
import store from '@/store';
//引入nprogress及其css样式，进度条颜色是可以改的
import nprogress from 'nprogress';
import 'nprogress/nprogress.css';
nprogress.configure({  });
const requests = axios.create({
   // baseURL: '/api',
   baseURL: '/cqitc/api',
   timeout: 5000
});

requests.interceptors.request.use((config) => {
    //进度条开始
    nprogress.start();
    if(config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
        config.data = qs.stringify(config.data)
    }
    /*if(store.state.detail.uuid_token) {
        config.headers.userTempId = store.state.detail.uuid_token;
    }
    //需要携带token带给服务器
    if(store.state.user.token) {
        config.headers.token = store.state.user.token;
    }*/
    return config;
}, () => {
    return Promise.reject(new Error('fail'));
});

requests.interceptors.response.use((res) => {
    //进度条结束
    nprogress.done();
    return res.data;
}, (error) => {
    return Promise.reject(new Error('fail'));
});

export default requests;
